module.exports = __webpack_public_path__ + "img/sms.9f5893d2.svg";